import { useCallback, useContext, useEffect } from 'react'
import {
   Avatar,
    Box,
    IconButton,
    ListItemButton,
    Typography,
    Tooltip,
    
} from '@mui/material'
import { AuthHandlerContext } from '../../App'
import { useDispatch, useSelector } from 'react-redux'
import LogOutIcon from '../../assets/icons/LogOutIcon'
import { selectUserDetails } from '../../selectors/user'
import commonActions from '../../actions/common.actions'
interface UserProfileMenuProps {
    hovered: boolean
    isOpen: boolean;
    onClick: () => void;
}

export function UserProfileMenu({ hovered, onClick }: UserProfileMenuProps) {
    const authHandlerContext = useContext(AuthHandlerContext)
    const userDetails = useSelector(selectUserDetails)
    const dispatch = useDispatch()

    const checkSystemTheme = useCallback(() => {
        const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
        const systemTheme = isDarkMode ? "Dark" : "Light";
        const savedTheme = localStorage.getItem("themeMode") || "Dark";
        const finalTheme = savedTheme === "System" ? systemTheme : savedTheme;
        commonActions.setThemeMode(dispatch, finalTheme as any);
    }, [dispatch]);

    useEffect(() => {
        checkSystemTheme();
    }, [checkSystemTheme]);

    useEffect(() => {
        const handleFocus = () => {
            checkSystemTheme();
        };

        window.addEventListener("focus", handleFocus);
        return () => {
            window.removeEventListener("focus", handleFocus);
        };
    }, [checkSystemTheme]);
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '42px' }}>
                <ListItemButton
                    onClick={onClick}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textTransform: 'none',
                        padding: '3px 16px 3px',
                        '&:hover': { background: theme => theme.palette.background.default }
                    }}
                >
                    <IconButton
                        data-event="Profile Icon Clicked"
                        sx={{ padding: 0 }}
                    >
                        <Avatar alt={userDetails.currentUser?.name} src={userDetails.currentUser?.avatarUrl} sx={{ width: 24, height: 24 }} />
                    </IconButton>
                    {hovered && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginLeft: '10px',
                            width: '190px',
                            overflow: 'hidden'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden',
                                flexGrow: 1
                            }}>
                                <Typography
                                    fontSize={12}
                                    color="textPrimary"
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%'
                                    }}
                                >
                                    {userDetails.currentUser?.name}
                                </Typography>
                                <Typography
                                    color="textSecondary"
                                    fontSize={12}
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%'
                                    }}
                                >
                                    {userDetails.currentUser?.email}
                                </Typography>
                            </Box>
                            <Box sx={{ ml: 1 }}>
                                <Tooltip title="Sign Out" arrow placement='top'>
                                    <ListItemButton
                                        data-event="Signed Out"
                                        onClick={() => authHandlerContext.onLoggedOut()}
                                        sx={{ minWidth: 'auto', p: 0 }}
                                    >
                                        <LogOutIcon />
                                    </ListItemButton>
                                </Tooltip>
                            </Box>
                        </Box>
                    )}
                </ListItemButton>
            </Box>
        </>
    )
}